import React, { useEffect, useState } from "react";
import Header from "./header";
import PanelChatUI from "app/views/Panels";

export default function Layout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [employeeId, setEmployeeId] = useState("");
    const [token, setToken] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        console.log("paramse", params);

        const empId = params.get("employee_id");
        const tkn = params.get("token");

        setEmployeeId(empId || "");
        setToken(tkn || "");
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="flex" style={{ top: 0, height: "100vh" }} >
            <div className="flex-1 flex flex-col overflow-hidden">
                <Header toggleSidebar={toggleSidebar} />
                <main className="flex-1 overflow-y-auto p-4">
                    <PanelChatUI />
                </main>
            </div>
        </div>
    );
}